class FaqSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('[data-input]'),
            this.results = this.querySelector('[data-search-results]');

        this.inputHandle = this.inputHandle.bind(this);
        this.getAllAnswers = this.getAllAnswers.bind(this);

        this.bindEvents();
    }
    bindEvents() {
        function debounce(func, timeout = 300) {
            let timer;
            return (...args) => {
                clearTimeout(timer);
                timer = setTimeout(() => { func.apply(this, args); }, timeout);
            };
        }
        const processChange = debounce((e) => this.inputHandle(e));
        this.input.addEventListener('input', processChange);

    }
    getAllAnswers(query) {
        const pagesToFetch = [
            '/pages/faq-about-divi',
            '/pages/faq-purchasing-divi',
            '/pages/faq-scalp-serum',
            '/pages/faq-shampoo-conditioner',
            '/pages/faq-hair-vitamins',
            '/pages/faq-club-divi',
            '/pages/faq-divi-specialists',
            '/pages/faq-other-faqs'
        ],
            parser = new DOMParser();

        let searchResults = [];
        pagesToFetch.forEach(async page => {
            fetch(page)
                .then((response) => response.text())
                .then((data) => {
                    let searchableContent = parser.parseFromString(data, 'text/html').querySelectorAll('[data-searchable-parent]');

                    searchableContent.forEach(content => {
                        if (content.textContent.toLowerCase().match(query.toLowerCase()) != null) {
                            searchResults.push(content);
                        }
                    })
                })
        });
        setTimeout(() => {
            this.results.innerHTML = '';

            if (searchResults.length < 1) {
                this.results.innerHTML = `<div class="search-results__title">No search results</div>`
            }

            searchResults.forEach(result => {
                this.results.innerHTML += `<a id="result-anchor" href="${result.dataset.masterUrl}">
                    <div class="search-results__title">${result.querySelector('.accordion-button--title').textContent}</div>
                    <div class="search-results__body">${result.querySelector('.accordion-body').textContent}</div>
                </a>`;
                
                document.querySelectorAll('.faq-tab-accordions .row .accordion-button').forEach(el => {
                    document.querySelectorAll('#result-anchor').forEach(resultAnchor => {
                        resultAnchor.addEventListener('click', () => {
                            console.log('click');
                            if (el.dataset.bsTarget.split('-')[el.dataset.bsTarget.split('-').length - 1] == resultAnchor.href.split('-')[resultAnchor.href.split('-').length - 1]) {
                                el.click()
                            }
                        })
                    });
                })
            })
        }, 2000)
    }
    inputHandle(e) {
        let query = e.target.value;
        this.results.innerHTML = '';

        if (query.length < 3) return;

        this.getAllAnswers(query);
    }
}
customElements.define('faq-search', FaqSearch);

// FAQ search accordion open on page load

if (window.location.href.indexOf("#") > -1 && document.querySelector('[data-search-results]')) {
    let urlParents = document.querySelectorAll('[data-searchable-parent]')
    let rootUrlNumArr = window.location.href.split('-')
    urlParents.forEach( urlParent => {
        if (rootUrlNumArr[rootUrlNumArr.length - 1] == urlParent.dataset.masterUrl.split('-')[urlParent.dataset.masterUrl.split('-').length - 1]) {
            urlParent.querySelector('.accordion-button').click()
        }
    });
}


const faqSearchForm = document.querySelector('.faq-search__form');

document.addEventListener('click', function(event) {
  if (!faqSearchForm.contains(event.target)) {
    document.querySelector('.faq-search__form .form-control').value = '';
    document.querySelector('.faq-search__form .search-results').innerHTML = '';
  }
});
